<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="门店名称">
          <el-input placeholder="请输入门店名称" v-model="formInline.search">
        
          </el-input>
        </el-form-item>

        <el-form-item label="审核状态">
        <el-select size="small" v-model="formInline.audit_status" placeholder="状态">
          <el-option label="全部" value=""></el-option>
          <el-option label="待审核" value="0"></el-option>
          <el-option label="通过" value="1"></el-option>
          <el-option label="不通过" value="2"></el-option>
        </el-select>
      </el-form-item>
        <el-form-item >
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>

      </el-form>
    </div>

 

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="store_name" label="门店名称"></el-table-column>
    
            <el-table-column prop="idcard" label="身份证号码"></el-table-column>
    
      
            <el-table-column label="营业执照">
              <template #default="{row}">
                <el-image
                  v-if="row.business_license"
                  style="width: 100px; height: 60px; cursor: pointer"
                  :src="row.business_license"
                  :preview-src-list="[row.business_license]"
                  fit="cover"
                  preview-teleported
                  hide-on-click-modal
                ></el-image>
                <span v-else>未上传</span>
              </template>
            </el-table-column>
      
            <el-table-column label="身份证正面">
              <template #default="{row}">
                <el-image
                  v-if="row.idcard_positive"
                  style="width: 100px; height: 60px; cursor: pointer"
                  :src="row.idcard_positive"
                  :preview-src-list="[row.idcard_positive]"
                  fit="cover"
                  preview-teleported
                  hide-on-click-modal
                ></el-image>
                <span v-else>未上传</span>
              </template>
            </el-table-column>
            
            <el-table-column label="身份证反面">
              <template #default="{row}">
                <el-image
                  v-if="row.idcard_reverse"
                  style="width: 100px; height: 60px; cursor: pointer"
                  :src="row.idcard_reverse"
                  :preview-src-list="[row.idcard_reverse]"
                  fit="cover"
                  preview-teleported
                  hide-on-click-modal
                ></el-image>
                <span v-else>未上传</span>
              </template>
            </el-table-column>  

            
            <el-table-column prop="audit_status" label="审核状态">
              <template #default="{row}">
                  <div v-if="row.audit_status == 0">未审核 </div>
                  <div v-if="row.audit_status == 1">审核通过 </div>
                  <div v-if="row.audit_status == 2">审核未通过：{{ row.reject_reason }} </div>
              </template>
            </el-table-column>
    



            <el-table-column prop="sort" label="排序" ></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button v-if="scope.row.audit_status == 0" @click="passClick(scope.row)" type="text" size="small">审核</el-button>
                <el-button v-if="scope.row.audit_status == 0" @click="nopassClick(scope.row)" type="text" size="small">审核不通过</el-button>
            
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :store_auth_id="store_auth_id"  v-if="open_edit"   @close="closeEdit"></Edit>

    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
    :close-on-click-modal="false" 
               :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>
  
  </div>
</template>

<script>
  import Store_authApi from '@/api/store_auth.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';

  export default {
    components: {
      Add,
      Edit,
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:""
        },

        open_add:false,
        open_edit:false,
        store_auth_id:"",
        dialogVisible:false,
      };
    },
    created() {

      /*获取列表*/
      this.getTableList();
    },
    methods: {
      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//门店认证标题设置
        // this.categorya_id = e
        this.dialogVisible = true;
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        Store_authApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.store_auth_id = row.store_auth_id;
        this.open_edit = true
      },
      passClick(item){//退款申请-通过审核
      var self = this;
      var Params = {
        store_auth_id:item.store_auth_id,
        audit_status:1
      }
      Store_authApi.passCanel(Params, true)
        .then(data => {
          console.log(data)
          if(data.code == 1){
            self.$message({
                type: 'success',
                message: '审核成功'
            });
              self.getTableList();
              return false;
          }
        })
        .catch(error => {
          
         
        });

    },
    async nopassClick(item){//退款申请-不通过审核
      var self = this;
      const reject_reason = await this.promptInput('请输入不通过的原图', '请输入2-4个汉字');

      var Params = {
        store_auth_id:item.store_auth_id,
        audit_status:2,
        reject_reason:reject_reason
      }
      Store_authApi.passCanel(Params, true)
        .then(data => {
          if(data.code == 1){
            self.$message({
                type: 'success',
                message: '审核成功'
            });
              self.getTableList();
              return false;
          }
        })
        .catch(error => {});
    },
    async promptInput(message, validation) {
      try {
        const { value } = await this.$prompt(message, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputErrorMessage: validation,
        });
        return value.trim();
      } catch(e) {
        this.$message({
          type: 'info',
          message: '取消输入',
        });
      }
    },
      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            Store_authApi.del(
              {
                store_auth_id: row.store_auth_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style>
.el-image {
  border: 1px solid #eee;
  border-radius: 4px;
  transition: all 0.3s;
}
.el-image:hover {
  transform: scale(1.05);
}

</style>



// WEBPACK FOOTER //
// src/views/plus/store_auth/index/index.vue